import { render, staticRenderFns } from "./MailList.vue?vue&type=template&id=4eacc1f8&"
import script from "./MailList.vue?vue&type=script&lang=js&"
export * from "./MailList.vue?vue&type=script&lang=js&"
import style0 from "./MailList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MailList.vue"
export default component.exports